/** Available block types. */
export enum BlockType {
  BLOG_BLOCK = 'BLOG_BLOCK',
  BODY_IMAGE_TITLE_SUBTITLE_LINK = 'BODY_IMAGE_TITLE_SUBTITLE_LINK',
  COLORED = 'COLORED',
  CONTACT = 'CONTACT',
  CONTACT_V1 = 'CONTACT_V1',
  IMAGE_BODY = 'IMAGE_BODY',
  PRODUCT_REFERENCE_BLOCK = 'PRODUCT_REFERENCE_BLOCK',
  TESTIMONIAL_BLOCK = 'TESTIMONIAL_BLOCK',
  TITLE_AND_BODY = 'TITLE_AND_BODY',
  TITLE_BODY_IMAGE = 'TITLE_BODY_IMAGE',
  TITLE_BODY_IMAGE_LINK = 'TITLE_BODY_IMAGE_LINK',
  TITLE_BODY_IMAGE_LINK_V1 = 'TITLE_BODY_IMAGE_LINK_V1',
  TITLE_BODY_IMAGE_OR_VIDEO = 'TITLE_BODY_IMAGE_OR_VIDEO',
  TITLE_BODY_LINK_IMAGE_POSITION = 'TITLE_BODY_LINK_IMAGE_POSITION',
  TITLE_IMAGE_LINK = 'TITLE_IMAGE_LINK',
  TITLE_SUBTITLE = 'TITLE_SUBTITLE',
  TITLE_SUBTITLE_IMAGE = 'TITLE_SUBTITLE_IMAGE',
  TITLE_SUBTITLE_LINK = 'TITLE_SUBTITLE_LINK',
  TITLE_USPS_IMAGE = 'TITLE_USPS_IMAGE',
  TITLE_WITH_IMAGES = 'TITLE_WITH_IMAGES',
  WITH_HAND = 'WITH_HAND',
  WITH_HAND_AND_LINK = 'WITH_HAND_AND_LINK',
}

/** Set of country codes. */
export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

/** Set of currencies. */
export enum Currency {
  AED = 'AED',
  ARS = 'ARS',
  AUD = 'AUD',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  COP = 'COP',
  DKK = 'DKK',
  EGP = 'EGP',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  JPY = 'JPY',
  KRW = 'KRW',
  LBP = 'LBP',
  MAD = 'MAD',
  MXN = 'MXN',
  MYR = 'MYR',
  NOK = 'NOK',
  NZD = 'NZD',
  PHP = 'PHP',
  PLN = 'PLN',
  QAR = 'QAR',
  RUB = 'RUB',
  SAR = 'SAR',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  TRY = 'TRY',
  TWD = 'TWD',
  UAH = 'UAH',
  USD = 'USD',
  VND = 'VND',
  ZAR = 'ZAR',
}

/** Customer types */
export enum CustomerType {
  /** Corporate customer. */
  BUSINESS = 'BUSINESS',
  /** Private customer. */
  PRIVATE = 'PRIVATE',
}

/** Represents available card types. */
export enum GiftCardVariationType {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
}

/** Search group types. */
export enum GroupTypes {
  GIFTCARD_PRODUCT = 'GIFTCARD_PRODUCT',
  GIVING_MOMENTS_ARTICLE = 'GIVING_MOMENTS_ARTICLE',
}

/** Set of languages. */
export enum Language {
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  it = 'it',
  nl = 'nl',
  pl = 'pl',
  sv = 'sv',
}

/** Location entity bundle IDs on the back-end. */
export enum LocationType {
  restaurant = 'restaurant',
}

/** Available main product types in the package. */
export enum MainProductType {
  DONATION = 'DONATION',
  GIFTCARD_BLANK = 'GIFTCARD_BLANK',
  GIFTCARD_DIGITAL = 'GIFTCARD_DIGITAL',
  GIFTCARD_PHYSICAL = 'GIFTCARD_PHYSICAL',
}

/** Contains some taxonomy_vocabulary IDs from enum VocabularyID. */
export enum OfferType {
  /** Global promotion vocabulary. */
  cb_api_giftcard_promotions = 'cb_api_giftcard_promotions',
}

export enum PackageAddingMode {
  DEFAULT = 'DEFAULT',
  SINGLE = 'SINGLE',
  SPLIT = 'SPLIT',
}

/** Enum fot personal message variation type. */
export enum PersonalMessageVariationType {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
}

/** Available product types. */
export enum ProductType {
  BLANK_GIFT_CARD_PACK = 'BLANK_GIFT_CARD_PACK',
  DIGITAL_WRAPPER = 'DIGITAL_WRAPPER',
  DONATION = 'DONATION',
  GIFTCARD = 'GIFTCARD',
  GIFT_PACKING = 'GIFT_PACKING',
  PERSONAL_MESSAGE = 'PERSONAL_MESSAGE',
  WRAPPER = 'WRAPPER',
}

export enum SearchType {
  GIFTCARD_PRODUCT = 'GIFTCARD_PRODUCT',
}

/** Represents Url type */
export enum UrlType {
  ABSOLUTE = 'ABSOLUTE',
  RELATIVE = 'RELATIVE',
}

export enum VideoProvider {
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
}

/** A list of taxonomy_vocabulary IDs. Some of them are in enum OfferType also. */
export enum VocabularyID {
  /** Global category Vocabulary. */
  cb_api_giftcard_categories = 'cb_api_giftcard_categories',
  /** Global promotion vocabulary. */
  cb_api_giftcard_promotions = 'cb_api_giftcard_promotions',
  /** Global giftcerd types Vocabulary. */
  cb_api_giftcard_types = 'cb_api_giftcard_types',
}
